import * as React from "react";
const SvgMore = (props) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.875 12H22.875M2.875 6H22.875M2.875 18H22.875", stroke: "currentColor", strokeWidth: 2 }));
export default SvgMore;
